import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0358cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("中文")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("English")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, { class: "ion-text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_logo_img)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/home" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "8",
                    "size-lg": "6",
                    "size-xl": "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "ion-text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_logo_img, { withText: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { position: "floating" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('LoginPage.loginEmail')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    inputmode: "email",
                                    type: "text",
                                    modelValue: $setup.loginEmail,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loginEmail) = $event)),
                                    enterkeyhint: "next",
                                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.focusInputField($setup.pswInput)), ["enter"]))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { position: "floating" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('LoginPage.password')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    ref: "pswInput",
                                    type: "password",
                                    modelValue: $setup.loginPsw,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.loginPsw) = $event)),
                                    enterkeyhint: "send",
                                    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => ($setup.doLogin($setup.loginEmail, $setup.loginPsw)), ["enter"]))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                class: "submit-btn",
                                expand: "block",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.doLogin($setup.loginEmail, $setup.loginPsw)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('LoginPage.login')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goToRegisterPage())),
                                    class: "ion-text-start text-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("small", null, _toDisplayString($setup.t('RegisterPage.registerAccount')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, {
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.goToForgotPasswordPage())),
                                    class: "ion-text-end text-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("small", null, _toDisplayString($setup.t('ForgotPasswordPage.forgotPassword')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        interface: "popover",
                        modelValue: $setup.locale,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.locale) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "zh" }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "en" }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}